// helpers/fullNameHelpers.js
export const getInitialValues = (drawerData, existingComponentIndex, readOnly) => {
    const state = drawerData[existingComponentIndex]?.state || {};
    return {
      nameValue: state.nameValue || "نام و نام خانوادگی",
      firstNameValue: state.firstNameValue || "نام",
      lastNameValue: state.lastNameValue || "نام خانوادگی",
      firstNameInput: state.mainFirstNameInput || "",
      lastNameInput: state.mainLastNameInput || "",
    };
  };
  
  export const updateDrawerState = (drawerData, index, state, readOnly) => {
    if (!drawerData[index]) return;
    drawerData[index].state = {
      ...drawerData[index].state,
      ...state,
      readOnly,
    };
  };
  
  export const validateName = (value) => /^[a-zA-Zآ-ی\s]+$/.test(value);
  